import styled from 'styled-components'
import { rgba } from 'polished'

export const Container = styled.div`
  position: relative;
  /* width: 100%; */
  margin-top: 10%;
  height: 100%;

  &:before {
    content: '';
    position: absolute;
    left: 14px;
    top: 5px;
    width: calc(100% + 50px);
    height: 4px;

    background: linear-gradient(
      to right,
      ${props => rgba(props.theme.colors.white, 0.06)} 0%,
      ${props => rgba(props.theme.colors.white, 0.6)} 60%,
      ${props => props.theme.colors.white} 100%
    );
    border-radius: 4px;

    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8a9196', endColorstr='#62696d',GradientType=1 );
  }

  .TimelineContent {
    position: relative;
    top: -2%;

    display: flex;
    gap: 1rem;
  }
`
export const TimelineMonth = styled.div`
  position: relative;

  width: auto;
  padding: 4px 15px 4px 35px;
  margin-bottom: 1.1rem;

  transform: translateY(-130%);

  background-color: ${props => rgba(props.theme.colors.white, 0.06)};
  border: 1px solid ${props => rgba(props.theme.colors.white, 0.1)};
  border-radius: 40px;
  border-right-color: black;

  display: inline-block;

  &:before {
    content: '';
    position: absolute;
    left: 5px;
    width: 20px;
    height: 20px;

    background: linear-gradient(
      to bottom,
      ${props => rgba(props.theme.colors.white, 0.06)} 0%,
      ${props => rgba(props.theme.colors.white, 0.1)} 60%,
      ${props => rgba(props.theme.colors.white, 0.2)} 100%
    );
    border-radius: 100%;
    border: 1px solid #17191b;

    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8a9196', endColorstr='#70787d',GradientType=0 );
  }

  &:after {
    content: '';
    position: absolute;
    left: 14px;
    top: 18px;
    width: 4px;
    height: 100%;

    background: linear-gradient(
      to bottom,
      ${props => rgba(props.theme.colors.white, 0.2)} 0%,
      ${props => rgba(props.theme.colors.white, 0.1)} 80%,
      ${props => rgba(props.theme.colors.white, 0.06)} 100%
    );
    border-radius: 4px;

    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8a9196', endColorstr='#62696d',GradientType=1 );
  }

  span {
    position: absolute;
    top: -1px;
    left: calc(100% - 10px);
    padding: 4px 10px 4px 20px;

    background-color: #111;
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
    border: 1px solid black;

    display: inline-block;
    white-space: nowrap;
    z-index: -1;
    box-sizing: border-box;
  }
`

export const TimelineSection = styled.div`
  position: relative;
  padding-left: 35px;

  display: flex;

  .timeline-date {
    position: relative;
    width: max-content;
    height: min-content;
    margin-bottom: 15px;
    padding: 2px 15px;

    display: inline-block;

    background: linear-gradient(
      45deg,
      ${props => props.theme.colors.primary.normal},
      ${props => props.theme.colors.primary.lighter} 10%,
      ${props => props.theme.colors.secondary}
    );
    border: 1px solid #17191b;
    border-radius: 20px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
    color: #fff;

    &:before {
      content: '';
      position: absolute;
      top: -100%;
      left: 10%;
      width: 1px;
      height: 40px;
      transform: translateY(-42%);

      background: linear-gradient(
        to top,
        ${props => props.theme.colors.primary.lighter} 0%,
        ${props => props.theme.colors.secondary} 100%
      );
    }

    &:after {
      content: '';
      position: absolute;
      top: -190%;
      left: 10%;
      width: 10px;
      height: 10px;
      transform: translateX(-50%);

      background: ${props => props.theme.colors.secondary};
      border: 1px solid #17191b;
      border-radius: 100%;
    }
  }

  .row {
    display: flex;
    gap: 15px;

    /* margin-left: -15px;
    margin-right: -15px; */
    .col {
      position: relative;
      min-height: 1px;
      height: fit-content;
      padding-left: 15px;
      padding-right: 15px;

      display: flex;

      .col {
        margin-top: 2rem;
      }

      @media (min-width: 768px) {
        float: left;
      }
    }
  }

  .timeline-box {
    position: relative;
    width: max-content;
    max-width: 300px;

    background-color: ${props => rgba(props.theme.colors.white, 0.06)};
    /* background: linear-gradient(
      to right,
      ${props => rgba(props.theme.colors.white, 0.06)} 0%,
      ${props => rgba(props.theme.colors.white, 0.6)} 60%,
      ${props => props.theme.colors.white} 100%
    ); */
    backdrop-filter: blur(2px);
    border-radius: 15px;
    border-top-left-radius: 0px;
    border-bottom-right-radius: 0px;
    border: 1px solid ${props => rgba(props.theme.colors.white, 0.1)};

    transition: all 0.3s ease;
    overflow: hidden;

    .box-icon {
      position: absolute;
      right: 5px;
      top: 0px;
    }

    .box-title {
      padding: 5px 15px;

      border-bottom: 1px solid #17191b;
      svg {
        margin-right: 5px;
        color: ${props => props.theme.colors.secondary};
      }
    }

    .box-content {
      padding: 5px 15px;

      background: ${props => rgba(props.theme.colors.background.dark, 0.4)};

      .tag {
        padding: 1px 5px;
        margin-bottom: 0px;

        white-space: nowrap;
        font-size: 12px;
        font-weight: normal;
        line-height: 1.5;
        text-align: center;
        vertical-align: middle;

        user-select: none;
        touch-action: manipulation;
        cursor: pointer;

        color: rgb(255, 255, 255);
        background-image: linear-gradient(
          rgb(72, 78, 85),
          rgb(58, 63, 68) 60%,
          rgb(49, 53, 57)
        );
        background-repeat: no-repeat;
        text-shadow: rgba(0, 0, 0, 0.3) 1px 1px 1px;
        border: 1px solid rgba(0, 0, 0, 0.6);
        border-radius: 3px;

        float: right !important;
      }

      strong {
        margin-right: 5px;

        color: #666;
        font-weight: bold;
        font-style: italic;
      }

      .box-item {
        margin-bottom: 5px;
      }
    }
    .box-footer {
      padding: 5px 15px;

      border-top: 1px solid #17191b;

      text-align: right;
      font-style: italic;
    }
  }
`
// export const Container = styled.div`
//   /* width: 100%; */
//   margin-top: 20px;
//   position: relative;
//   height: 100%;

//   /* transform: rotateZ(270deg); */

//   &:before {
//     content: '';
//     position: absolute;
//     left: 14px;
//     top: 5px;
//     width: calc(100% + 50px);
//     height: 4px;
//     /* width: 4px;
//     height: calc(100% + 50px); */

//     background: rgb(138, 145, 150);
//     background: -moz-linear-gradient(
//       left,
//       rgba(138, 145, 150, 1) 0%,
//       rgba(122, 130, 136, 1) 60%,
//       rgba(98, 105, 109, 1) 100%
//     );
//     background: -webkit-linear-gradient(
//       left,
//       rgba(138, 145, 150, 1) 0%,
//       rgba(122, 130, 136, 1) 60%,
//       rgba(98, 105, 109, 1) 100%
//     );
//     background: linear-gradient(
//       to right,
//       rgba(138, 145, 150, 1) 0%,
//       rgba(122, 130, 136, 1) 60%,
//       rgba(98, 105, 109, 1) 100%
//     );
//     border-radius: 4px;

//     filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8a9196', endColorstr='#62696d',GradientType=1 );
//   }
// `
// export const TimelineMonth = styled.div`
//   position: relative;

//   width: auto;
//   padding: 4px 15px 4px 35px;
//   margin-bottom: 30px;

//   background-color: #444950;
//   border-radius: 40px;
//   border: 1px solid #17191b;
//   border-right-color: black;

//   display: inline-block;

//   span {
//     position: absolute;
//     top: -1px;
//     left: calc(100% - 10px);
//     padding: 4px 10px 4px 20px;

//     background-color: #111;
//     border-top-right-radius: 40px;
//     border-bottom-right-radius: 40px;
//     border: 1px solid black;

//     display: inline-block;
//     white-space: nowrap;
//     z-index: -1;
//     box-sizing: border-box;
//   }

//   &:before {
//     content: '';
//     position: absolute;
//     left: 5px;
//     width: 20px;
//     height: 20px;

//     background: rgb(138, 145, 150);
//     background: -moz-linear-gradient(
//       top,
//       rgba(138, 145, 150, 1) 0%,
//       rgba(122, 130, 136, 1) 60%,
//       rgba(112, 120, 125, 1) 100%
//     );
//     background: -webkit-linear-gradient(
//       top,
//       rgba(138, 145, 150, 1) 0%,
//       rgba(122, 130, 136, 1) 60%,
//       rgba(112, 120, 125, 1) 100%
//     );
//     background: linear-gradient(
//       to bottom,
//       rgba(138, 145, 150, 1) 0%,
//       rgba(122, 130, 136, 1) 60%,
//       rgba(112, 120, 125, 1) 100%
//     );
//     border-radius: 100%;
//     border: 1px solid #17191b;

//     filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8a9196', endColorstr='#70787d',GradientType=0 );
//   }
// `

// export const TimelineSection = styled.div`
//   position: relative;
//   padding-left: 35px;
//   margin-bottom: 30px;

//   display: block;

//   &:before {
//     content: '';
//     position: absolute;
//     top: 12px;
//     left: 20px;
//     width: 30px;
//     height: 1px;

//     background-color: #444950;
//   }

//   &:after {
//     content: '';
//     position: absolute;
//     top: 7px;
//     left: 11px;
//     width: 10px;
//     height: 10px;

//     background: linear-gradient(
//       to bottom,
//       rgba(138, 145, 150, 1) 0%,
//       rgba(122, 130, 136, 1) 60%,
//       rgba(112, 120, 125, 1) 100%
//     );
//     border: 1px solid #17191b;
//     border-radius: 100%;
//   }

//   .col-sm-4 {
//     margin-bottom: 15px;
//   }

//   .timeline-date {
//     position: relative;
//     margin-bottom: 15px;
//     padding: 2px 15px;

//     display: inline-block;

//     background: linear-gradient(#74cae3, #5bc0de 60%, #4ab9db);
//     border: 1px solid #17191b;
//     border-radius: 20px;
//     text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
//     color: #fff;
//   }

//   .timeline-box {
//     position: relative;
//     width: min-content;

//     background-color: #444950;
//     border-radius: 15px;
//     border-top-left-radius: 0px;
//     border-bottom-right-radius: 0px;
//     border: 1px solid #17191b;

//     transition: all 0.3s ease;
//     overflow: hidden;
//   }

//   .box-icon {
//     position: absolute;
//     right: 5px;
//     top: 0px;
//   }

//   .box-title {
//     padding: 5px 15px;

//     border-bottom: 1px solid #17191b;
//   }

//   .box-title i {
//     margin-right: 5px;
//   }

//   .box-content {
//     padding: 5px 15px;

//     background-color: #17191b;
//   }

//   .box-content strong {
//     margin-right: 5px;

//     color: #666;
//     font-style: italic;
//   }

//   .box-item {
//     margin-bottom: 5px;
//   }

//   .box-footer {
//     padding: 5px 15px;

//     border-top: 1px solid #17191b;
//     background-color: #444950;

//     text-align: right;
//     font-style: italic;
//   }
// `
